import React from 'react';
import './harbour.css';

/*
 * Harbour/Progress segment strip: one rounded bar per stage, filled when the
 * stage is done; the current stage can show partial fill ("answered m of n").
 * Progress is always presented alongside counts in text — the strip itself is
 * decorative reinforcement, so it is hidden from assistive tech and the
 * caller provides the textual count (e.g. "Question 4 of 12").
 */
export default function HarbourProgressSegments({
  tone = 'sen',
  total,
  doneCount = 0,
  currentFraction = 0,
  weights = null,
  className = '',
}) {
  if (!total || total < 1) return null;
  const segments = Array.from({ length: total }, (_, i) => {
    let fill = 0;
    if (i < doneCount) fill = 1;
    else if (i === doneCount) fill = Math.max(0, Math.min(1, currentFraction));
    return fill;
  });

  return (
    <div className={`harbour-segments ${className}`.trim()} aria-hidden="true">
      {segments.map((fill, i) => (
        <span
          key={i}
          className={`harbour-segment harbour-segment--${tone}`}
          // Segment widths proportional to questions per part (the design's
          // weighted progress bar); without weights every part is equal.
          style={Array.isArray(weights) && weights[i] > 0 ? { flexGrow: weights[i] } : undefined}
        >
          {fill > 0 && <span className="harbour-segment__fill" style={{ width: `${fill * 100}%` }} />}
        </span>
      ))}
    </div>
  );
}
